import React, { useId } from 'react';

/**
 * Single free-text name field — the opening step of both wizards.
 *
 * The label carries `htmlFor` because it neither wrapped the input nor named it, so it was
 * announced as an unlabelled text box and was unreachable by `getByLabelText`. `useId`
 * rather than a literal: both wizards render this, and `label` is a prop, so there is no
 * string here that is unique by construction.
 */
function NameStep({ label, placeholder, hint, value, onChange }) {
  const inputId = useId();

  return (
    <div className="form-group">
      <label htmlFor={inputId}>{label}</label>
      <input
        id={inputId}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoFocus
        required
      />
      {hint && <p className="helper-text">{hint}</p>}
    </div>
  );
}

export default NameStep;
